export const isRecent = (date, days) => {
  const difference = Date.now() - new Date(`${date}T12:00:00`).getTime();
  return difference >= 0 && difference <= days * 86400000;
};

export const formatRelativeTime = (date) => {
  const days = Math.max(0, Math.floor((Date.now() - new Date(`${date}T12:00:00`)) / 86400000));
  if (days === 0) return 'today';
  if (days === 1) return '1d ago';
  if (days < 14) return `${days}d ago`;
  if (days < 45) return `${Math.floor(days / 7)}w ago`;
  return `${Math.floor(days / 30)}mo ago`;
};

export const matchesQuery = (app, query) => {
  if (!query) return true;
  const haystack = [app.name, app.tagline, app.category, ...app.tags].join(' ').toLowerCase();
  return haystack.includes(query.toLowerCase());
};

export const matchesTab = (app, tab) => {
  if (tab === 'featured') return app.featured;
  if (tab === 'new') return isRecent(app.createdAt, 30);
  return true;
};

export const filterApps = (apps, state, excludedGroup) => apps.filter((app) => {
  if (!matchesQuery(app, state.query)) return false;
  if (excludedGroup !== 'category' && state.category !== 'All' && app.category !== state.category) return false;
  if (!matchesTab(app, state.tab)) return false;

  if (
    excludedGroup !== 'status' &&
    state.statusFilters.length &&
    !state.statusFilters.includes(app.status)
  ) return false;

  if (
    excludedGroup !== 'tech' &&
    state.techFilters.length &&
    !state.techFilters.some((tag) => app.tags.includes(tag))
  ) return false;

  return true;
});

export const sortApps = (apps, sort, tab) => {
  const result = [...apps];
  if (tab === 'featured' || sort === 'popular') {
    return result.sort((a, b) => b.stats.views - a.stats.views);
  }
  if (sort === 'newest') {
    return result.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }
  if (sort === 'updated') {
    return result.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  }
  return result.sort((a, b) => a.name.localeCompare(b.name));
};

export const parseInitialState = () => {
  const params = new URLSearchParams(window.location.search);

  return {
    query: params.get('q') || '',
    category: params.get('cat') || 'All',
    tab: 'all',
    sort: 'popular',
    view: 'grid',
    statusFilters: [],
    techFilters: [],
    page: Math.max(1, Number(params.get('page')) || 1)
  };
};

export const syncUrl = (state) => {
  const params = new URLSearchParams();
  const values = {
    q: state.query,
    cat: state.category === 'All' ? '' : state.category,
    page: state.page > 1 ? state.page : ''
  };

  Object.entries(values).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });

  const query = params.toString();
  window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
};

export const toggleArrayValue = (values, value) => (
  values.includes(value) ? values.filter((item) => item !== value) : [...values, value]
);